
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1359","height":"500","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1359 0H0v499.68h1359V0z","fill":"#4D4D4D"}}),_c('path',{attrs:{"d":"M33.84 20.58H20.86c-6.633 0-12.01 5.377-12.01 12.01v.98c0 6.633 5.377 12.01 12.01 12.01h12.98c6.633 0 12.01-5.377 12.01-12.01v-.98c0-6.633-5.377-12.01-12.01-12.01zM32.99 451H20.01C13.377 451 8 456.377 8 463.01v.98C8 470.623 13.377 476 20.01 476h12.98c6.633 0 12.01-5.377 12.01-12.01v-.98c0-6.633-5.377-12.01-12.01-12.01zM1337.16 20.41h-12.98c-6.63 0-12.01 5.377-12.01 12.01v.98c0 6.633 5.38 12.01 12.01 12.01h12.98c6.63 0 12.01-5.377 12.01-12.01v-.98c0-6.633-5.38-12.01-12.01-12.01zm-.17 440.59h-12.98c-6.63 0-12.01 5.377-12.01 12.01v.98c0 6.633 5.38 12.01 12.01 12.01h12.98c6.63 0 12.01-5.377 12.01-12.01v-.98c0-6.633-5.38-12.01-12.01-12.01zM1268 .32v.45c0 8.13 2.28 14.73 5.1 14.73s5.1-6.6 5.1-14.73V.32H1268zm0 499.68v-.45c0-8.13 2.28-14.72 5.1-14.72s5.1 6.59 5.1 14.72v.45H1268zM69 500v-.45c0-8.13 2.28-14.72 5.1-14.72s5.1 6.59 5.1 14.72v.45H69zM69 0v.45c0 8.13 2.28 14.72 5.1 14.72S79.2 8.58 79.2.45V0H69z","fill":"#fff"}})])
          )
        }
      }
    